<template>
  <div class="">
    <div class="mapStyle" id="map">
    </div>
    <div id="mapHeaderIcon">
      <img :src="imgSrc" class="mapIcon" height="50px"/>
    </div>
    <MapComponent id="legend" inputClass="overlay-tr">
      <template slot="header">
        <h6>Legend</h6>
      </template>
      <template slot="body">
        <table class="table table-sm table-borderless m-0">
          <tbody>
            <tr v-for="(item,index) in Object.keys(pointColor)" :key="index" class="pt-0 pb-0" @click="rowClicked(item)" :id="item+'Label'">
              <td>
                <svg height="12" width="12">
                  <circle cx="6" cy="6" r="5" stroke="black" stroke-width="0.5" :fill="pointColor[item]"/>
                </svg>
              </td>
              <td >{{item}}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </MapComponent>
    <div id="popup">
      <!-- <a href="#" id="popup-closer" class="ol-popup-closer"></a> -->
      <dl id="popup-content" class="col-12">
        <template v-if="popupData.project_name">
          <dt>Name</dt>
          <dd>{{popupData.project_name}}</dd>
        </template>
        <!-- <template v-if="popupData.contractor"> -->
          <dt>Contractor</dt>
          <dd>{{popupData.contractor}}</dd>
        <!-- </template> -->
        <template v-if="popupData.pavement_type">
          <dt>Pavement</dt>
          <dd>{{popupData.pavement_type}}</dd>
        </template>
        <template v-if="popupData.state">
          <dt>State</dt>
          <dd>{{popupData.state}}</dd>
        </template>
        <template v-if="popupData.suburb">
          <dt>Suburb</dt>
          <dd>{{popupData.suburb}}</dd>
        </template>
        <template v-if="popupData.year_paved">
          <dt>Year Paved</dt>
          <dd>{{popupData.year_paved}}</dd>
        </template>
      </dl>
    </div>
  </div>
</template>

<script>
import { MapboxStyleSwitcherControl } from "mapbox-gl-style-switcher";
import mapboxgl from "mapbox-gl";
import "mapbox-gl-style-switcher/styles.css";
require('mapbox.js')

import 'mapbox-gl/src/css/mapbox-gl.css'
import {mapBoxToken} from '../../../token-config.js'
import MapComponent from './../PavementBody/MapComponent.vue'
// import Map from 'mapbox-gl/src/ui/map.js'
// import * as styles from '@mapbox-gl/src/style'
export default {
  name: "MapBoxMap",
  components: {
    MapComponent
  },
  props: {
    generateMapFlag: Boolean,
    geoJsonData: Object
  },
  data() {
    return {
      map: {},
      popup: {},
      legendControl: {},
      popupData: {
        contractor: "",
        dc: "",
        pavement_type: "",
        postcode: "",
        project_name: "",
        state: "",
        suburb: "",
        year_paved: "",
      },
      logoSrcList: [
        "assets/Logo-horizontal-on-black.png",
        "assets/Logo-horizontal-on-grey.png",
        "assets/Logo-horizontal-on-orange.png",
        "assets/Logo-horizontal-on-white.png"
      ],
      imgSrc: "assets/Logo-horizontal-on-black.png",
      pointColor:{
        PCP: "#2ecc71",
        CRCP: "#9b59b6",
        JRCP: "#3498db",
        'Not Known': "#e74c3c"
      }

    }
  },
  mounted() {
    // will be fetched using a free created account
    const current = this
    var unclusteredPointTypes = [
      'unclustered-point_PCP',
      'unclustered-point_JRCP',
      'unclustered-point_CRCP',
      'unclustered-point_NONE'
    ]
    var routeTypes = [
      'route_PCP',
      'route_JRCP',
      'route_CRCP',
      'route_Not Known'
    ]
    mapboxgl.accessToken = mapBoxToken
    current.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/dark-v9?optimize=true', // stylesheet location
      center: [151.2093, -33.8688], // starting position [lng, lat]
      minZoom: 4,
      maxZoom: 17,
      zoom: 6 // starting zoom
    });
    var styleSwitcherOptions = {
      eventListeners: {
        onChange: function(event) {
          setTimeout(() => {
            current.renderData();
            if (["Outdoors","Light", "Streets"].includes(event.srcElement.outerText)) {
              current.imgSrc = current.logoSrcList[3]
            }
            // else if ([""].includes(event.srcElement.outerText)) {
            //   current.imgSrc = current.logoSrcList[2]
            // }
            else if (["Dark", "Satellite"].includes(event.srcElement.outerText)) {
              current.imgSrc = current.logoSrcList[0]
            }
            else {
              current.imgSrc = current.logoSrcList[1]
            }
          },700)
        }
      }
    }
    current.popup = new mapboxgl.Popup().setDOMContent(document.getElementById("popup"))
    var legend = document.getElementById('legend');
    var navigationControl = new mapboxgl.NavigationControl({});
    var fullScreenControl = new mapboxgl.FullscreenControl({});
    var legendControl = {
      onAdd(map) {
        this._map = map;
        this._container = document.getElementById('legend');
        this._container.className = 'legendControl mapboxgl-ctrl card';
        return this._container;
      },
      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }
    var iconHeader = {
      onAdd(map) {
        this._map = map;
        this._container = document.getElementById('mapHeaderIcon');
        this._container.className = 'mapboxgl-ctrl mapIcon';
        return this._container;
      },
      onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
      }
    }
    current.map.addControl(legendControl,'top-right')
    current.map.addControl(iconHeader, 'top-left')
    current.map.addControl(navigationControl, 'top-left')
    current.map.addControl(fullScreenControl, 'top-left')
    current.map.addControl(new MapboxStyleSwitcherControl(null,styleSwitcherOptions),'top-left');

    routeTypes.forEach(type=>{
      current.map.on('mouseenter', type, function () {
        current.map.getCanvas().style.cursor = 'pointer';
      });
      current.map.on('mouseleave', type, function () {
        current.map.getCanvas().style.cursor = '';

      });

      current.map.on('click', type, function(event){
        event.preventDefault();
        try {
          var coordinatesStart = [
            parseFloat(event.features[0].properties.startPointLong),
            parseFloat(event.features[0].properties.startPointLat)
          ]
          var coordinatesEnd = [
            parseFloat(event.features[0].properties.endPointLong),
            parseFloat(event.features[0].properties.endPointLat)
          ]
          // var coordinates = [(coordinatesStart[0]+coordinatesEnd[0])/2,(coordinatesStart[1]+coordinatesEnd[1])/2]
          var coordinates = [event.lngLat.lng, event.lngLat.lat]
          var properties = event.features[0].properties
          Object.keys(properties).forEach((item)=>{
            if (properties[item] != "null") {
              current.popupData[item] = properties[item]
            }
            else {
              current.popupData[item] = ""
            }
          })
          current.popup.setLngLat(coordinates).addTo(current.map)

        } catch (error) {
          console.log(error);
          console.log(event.features[0].geometry.coordinates);
          console.log(event.features);
          console.log(coordinates);
        }
      })
    })
    current.map.on("load", function() {
      current.renderData();
    })
  },
  watch: {

  },
  methods: {
    rowClicked: function(data) {
      const current = this
      let label = document.getElementById(data+"Label")
      label.classList.toggle("strikeThrough")
      // var clusterId = "clusters_"+data
      // var clusterCountId = "cluster-count_"+data
      // var unclusteredPointId = "unclustered-point_"+data
      var isVisible = label.classList.contains("strikeThrough")?false:true
      // current.map.setLayoutProperty(clusterId, 'visibility', isVisible?'visible':'none')
      // current.map.setLayoutProperty(clusterCountId, 'visibility', isVisible?'visible':'none')
      // current.map.setLayoutProperty(unclusteredPointId, 'visibility', isVisible?'visible':'none')
      var routeId = "route_"+data
      current.map.setLayoutProperty(routeId, 'visibility', isVisible?'visible':'none')
    },
    renderData: function () {
      const current = this;
      var layerTypes = ["PCP","JRCP","CRCP","Not Known"];
      layerTypes.forEach(layerType=>{
        if (typeof current.geoJsonData[layerType] != "undefined" && typeof current.geoJsonData[layerType].type != "undefined") {
          if (current.map.getLayer("route_"+layerType)) {
            current.map.removeLayer("route_"+layerType)
          }
          if (current.map.getSource(layerType)) {
            current.map.removeSource(layerType)
          }
          current.map.addSource(layerType, {
            type: "geojson",
            data: current.geoJsonData[layerType]
          })
          current.map.addLayer({
              'id': "route_"+layerType,
              'type': 'line',
              'source': layerType,
              'layout': {
                'line-join': 'round',
                'line-cap': 'round'
              },
              'paint': {
                'line-color': current.pointColor[layerType],
                'line-width': 4
              }
          });
        }
      })
    },

  }
}
</script>

<style lang="css">
  .mapStyle {
    position:absolute;
    top:0;
    bottom:0;
    width:100%;
  }
  .legendControl {
    font-family: 'Montserrat';
  }
  .mapIcon {
    position: absolute;
    top: 0.5px;
    left: 1.75em;
  }
  .strikeThrough {
    text-decoration: line-through;
    text-emphasis-style: none;
  }
  .mapboxgl-popup-content {
    font-family: 'Montserrat';
  }
</style>
